require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./works-2018-06-29-clerestory.json") })
        }
      }, "path---works-2018-06-29-clerestory");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---works-2018-06-29-clerestory!./.cache/json/works-2018-06-29-clerestory.json
// module id = 415
// module chunks = 231608221292675